import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  const {
    form,
    submit: submitButton,
    success: successContent,
    error: errorContent,
    serverError: serverErrorContent,
    captchaContainer,
  } = choozy(node);

  const { formAction } = node.dataset;
  const siteKey = window.theme.googleCaptcha.key;
  const verificationUrl = window.theme.googleCaptcha.verificationEndpoint;

  let captchaVerfied = false;
  let widgetId;

  const getCaptchaToken = () => window.grecaptcha.getResponse(widgetId);

  const verifyCaptchaToken = async (token) => {
    const response = await fetch(verificationUrl, {
      method: 'POST',
      body: JSON.stringify({
        token,
      }),
    });
    return response.json();
  };

  const veryifyUser = async () => {
    // No need for try catch here as this function is called in a try catch
    const token = await getCaptchaToken();

    if (!token) {
      // eslint-disable-next-line no-alert
      alert(
        window?.theme?.strings?.fill_in_captcha_alert || 'Check the reCaptcha checkbox to submit',
      );
      captchaContainer.style.border = 'solid 2px red';
      return Promise.reject(new Error('Captcha is required'));
    }

    const data = await verifyCaptchaToken(token);

    if (data?.success) {
      captchaVerfied = true;
      return Promise.resolve();
    }

    return Promise.reject(new Error('Failed Captcha test'));
  };

  const submitToDixa = async () => {
    if (!captchaVerfied) return;

    submitButton.disabled = true;
    successContent.hidden = true;
    errorContent.hidden = true;
    serverErrorContent.hidden = true;

    try {
      const response = await fetch(formAction, {
        method: 'POST',
        body: new FormData(form),
      });

      if (response?.ok) {
        successContent.hidden = false;
        successContent.focus();
        form.reset();
      } else if (response) {
        errorContent.hidden = false;
        errorContent.focus();
      }
    } catch {
      serverErrorContent.hidden = false;
      serverErrorContent.focus();
    } finally {
      submitButton.disabled = false;
    }
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    try {
      await veryifyUser();
      await submitToDixa(new FormData(form));
    } catch {
      serverErrorContent.hidden = false;
      serverErrorContent.focus();
    }
  });

  const renderCaptcha = () => {
    if (!window.grecaptcha) return;

    widgetId = window.grecaptcha.render(captchaContainer, {
      sitekey: siteKey,
      theme: 'light',
      callback: () => {
        captchaContainer.style.removeProperty('border');
      },
    });
  };

  if (!window.theme.googleCaptcha.ready) {
    document.addEventListener('reCaptchaReady', renderCaptcha, {
      once: true,
    });
  } else {
    renderCaptcha();
  }
});
